/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';


export interface VMCARemediationSpec { 
    spec_type?: ResourceProvider;
    /**
     * Access token holding an org owner perm.
     */
    org_owner_access_token: string;
}
export namespace VMCARemediationSpec {
}


